<template>
  <Tooltip :text="tooltip">
    <label class="group relative flex max-w-min cursor-pointer gap-2.5" :for="id" :aria-label="$t('select')">
      <input
        :id="id"
        v-model="inputValue"
        :class="[
          'peer relative aspect-square size-5 shrink-0 cursor-pointer appearance-none rounded-md border transition-all duration-300',
          'bg-checkbox-bgr-default group-focus:shadow-focus group-hover:bg-checkbox-bgr-hover border-checkbox-bdr-default group-hover:border-checkbox-bdr-hover',
          'disabled:border-checkbox-bdr-disabled! disabled:text-checkbox-fgr-disabled! disabled:bg-checkbox-bgr-disabled! hover:border-checkbox-bdr-disabled hover:bg-checkbox-bgr-disabled disabled:cursor-default',
          'checked:border-checkbox-bgr-active checked:text-checkbox-fgr-active checked:bg-checkbox-bgr-active checked:group-hover:border-checkbox-bgr-active-hover checked:group-hover:bg-checkbox-bgr-active-hover',
          'indeterminate:border-checkbox-bgr-active indeterminate:text-checkbox-fgr-active indeterminate:bg-checkbox-bgr-active indeterminate:group-hover:border-checkbox-bgr-active-hover indeterminate:group-hover:bg-checkbox-bgr-active-hover',
          {
            'bg-checkbox-bgr-critical! group-hover:bg-checkbox-bgr-critical-hover! border-checkbox-bdr-critical! group-hover:border-checkbox-bdr-critical-hover!':
              error,
          },
        ]"
        :disabled="readonly"
        type="checkbox"
        :indeterminate
      />
      <div
        class="peer-checked:text-bgr-primary peer-indeterminate:text-bgr-primary peer-disabled:text-state-fgr-disabled pointer-events-none absolute grid size-5 place-content-center text-inherit opacity-0 transition-opacity peer-checked:opacity-100 peer-indeterminate:opacity-100"
      >
        <Icon v-if="indeterminate" :size="ComponentSize.sm" src="bold/Minus" />
        <Icon v-else :size="ComponentSize.sm" src="bold/Check" />
        <slot />
      </div>
    </label>
  </Tooltip>
</template>

<script setup lang="ts">
  const id = `checkbox-${useId()}`;

  const props = withDefaults(
    defineProps<{
      activeValue?: boolean | number;
      error?: boolean;
      indeterminate?: boolean;
      name?: string;
      readonly?: boolean;
      tooltip?: string;
    }>(),
    {
      activeValue: false,
      error: false,
      indeterminate: false,
      name: "",
      readonly: false,
      tooltip: "",
    }
  );

  defineModel<boolean>();

  const activeValue = computed(() => props.activeValue);

  onMounted(() => {
    if (props.activeValue) {
      inputValue.value = true;
    }
  });

  const { value: inputValue, errorMessage } = useField(() => props.name, undefined, {
    type: "checkbox",
    checkedValue: true,
    uncheckedValue: false,
    syncVModel: props.name ? false : true,
    controlled: !!props.name,
  });

  watch(activeValue, (newValue) => {
    inputValue.value = newValue;
  });

  const error = computed(() => {
    return props.error || errorMessage.value;
  });
</script>
